<script>
import GPTAssistants from "@/views/component/GPTAssistants.vue";

export default {
  components: {
    GPTAssistants: GPTAssistants
  },
  data() {
    return {
      visible: false
    }
  },
  methods: {
    handleExploreAIClick() {
      // 组件内部管理弹窗显示状态
      this.visible = true;
    },
    handleCloseModal() {
      this.visible = false;
    },
    handleLinkedinClick() {
      window.open("www.linkedin.com/company/anvision-digital");
    },
    handleNavigateClick(refName) {
      // 向上遍历查找包含 refs 的父组件
      let parent = this.$parent;
      let targetElement = null;
      
      // 向上查找直到找到包含对应ref的组件
      while (parent) {
        if (parent.$refs && parent.$refs[refName]) {
          targetElement = parent.$refs[refName];
          // console.log("找到目标元素:", targetElement);
          break;
        }
        parent = parent.$parent;
      }
      
      if (targetElement) {
        // 获取元素相对于文档的位置
        const rect = targetElement.getBoundingClientRect();
        const distanceY = rect.top + window.pageYOffset - window.innerHeight * 0.07;
        
        // console.log("rect.top", rect.top);
        // console.log("window.pageYOffset", window.pageYOffset);
        // console.log("distanceY", distanceY);
        
        window.scrollTo({
          top: distanceY,
          left: 0,
          behavior: 'smooth'
        });
      }
    }
  }
}
</script>

<template>
  <div class="NavigationButtonsContainer">
    <!-- GPT 工具弹窗 -->
    <div v-if="visible" class="modal-overlay" @click="handleCloseModal">
      <div class="gptassistent" @click.stop>
        <GPTAssistants></GPTAssistants>
      </div>
      <img @click="handleCloseModal" class="close-btn" src="@/assets/error.png">
    </div>

    <!-- Navigation Buttons -->
    <div class="Navigation">
      <div class="N1" style="position: relative" @click="handleExploreAIClick">
        <div style="padding: 0 0 0 1vw">
          Explore AI Tools
        </div>
        <div style="height: 1.4vw;position: absolute;right: 1vw">
          <img style="width: 1.4vw;" src="@/assets/more_btn_icon.png_white.png">
        </div>
      </div>
      <div class="N1" id="N2" @click="handleLinkedinClick">
        <div style="margin: auto 1vw auto 1vw;width: 1.8vw;height: 1.8vw">
          <img style="width: 1.8vw;height: 1.8vw" src="@/assets/linkin_blue.png">
        </div>
        <div>
          Follow Us,Free Use
        </div>
      </div>
    </div>

    <!-- Bottom Content Cards -->
    <div class="bottomContent">
      <div class="item" @click="handleNavigateClick('consultMove')">
        <div class="content1">Smart Oilfield</div>
        <div class="content2">Full - scenario digital - intelligent oilfield solutions</div>
        <div class="content3">
          <img src="@/assets/more_btn_icon.png_black.png">
        </div>
      </div>
      <div class="item" @click="handleNavigateClick('professional')">
        <div class="content1">Customized AI</div>
        <div class="content2">Customization of AI applications in oil and gas industry scenarios</div>
        <div class="content3">
          <img src="@/assets/more_btn_icon.png_black.png">
        </div>
      </div>
      <div class="item" @click="handleNavigateClick('software')">
        <div class="content1">Software Products</div>
        <div class="content2">Full - scenario digital - intelligent oilfield products and software development</div>
        <div class="content3">
          <img src="@/assets/more_btn_icon.png_black.png">
        </div>
      </div>
      <div class="item" @click="handleNavigateClick('mediaMove')">
        <div class="content1">Intelligent Multimedia</div>
        <div class="content2">To boost your brand's spread in the digital wave</div>
        <div class="content3">
          <img src="@/assets/more_btn_icon.png_black.png">
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.NavigationButtonsContainer {
  width: 100%;
  font-family: Sora;

  // 弹窗样式
  .modal-overlay {
    position: fixed;
    width: 100%;
    height: 100%;
    background-color: rgba(128, 128, 128, 0.5);
    top: 0;
    left: 0;
    z-index: 9999999;
  }

  .gptassistent {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translateY(-50%) translateX(-50%);
    width: 95%;
    height: 70%;
    z-index: 9999;
    overflow-y: scroll;
  }

  .close-btn {
    height: 2vw;
    width: 2vw;
    position: fixed;
    right: 3vw;
    top: 9vh;
    cursor: pointer;
  }

  .Navigation {
    width: 100%;
    height: 5.5vh;
    display: grid;
    padding: 0 29vw;
    gap: 5vw;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);

    .N1 {
      height: 100%;
      display: flex;
      cursor: pointer;
      background-color: #117cd1;
      font-size: 1.2vw;
      border-radius: 9px;
      color: white;
      text-align: center;
      align-items: center;
      background-size: cover;
    }
  }

  .bottomContent {
    display: grid;
    width: 100%;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr);
    margin-top: 10vh;
    padding: 0 3vw;
    font-size: 1.2vw;
    font-weight: bolder;
    align-items: center;
    height: fit-content;

    .item {
      height: 100%;
      position: relative;
      padding: 4vh 2.5vw;
      border: 2px solid #dcdfe6;
      text-align: left;
      font-weight: normal;
      cursor: pointer;
      margin-left: 1vw;
      background-color: rgb(246, 246, 246);
      border-radius: 28px;

      .content1 {
        font-size: 1.2vw;
      }

      .content2 {
        font-size: 1vw;
        color: gray;
        margin-top: 2vh;
      }

      .content3 {
        position: absolute;
        right: 1.5vw;
        top: 1.5vw;

        img {
          width: 1.8vw;
          height: 1.8vw;
        }
      }
    }
  }
}
</style>

